import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import EN from './Locales/EN/Translation.json'
import HI from './Locales/HI/Translation.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: EN },
      hi: { translation: HI }
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;
